import classNames from 'classnames';
import { useHits } from 'react-instantsearch';
import CaseStudyItem from '../case-study-item/case-study-item';
import LinkWrapper from '../link-wrapper/link-wrapper';
import type { CaseStudyHit } from '../search/search-hit-types';

export function SearchHitsCaseStudies() {
    const { items } = useHits<CaseStudyHit>();

    return (
        <div>
            <ul className="md:grid md:grid-cols-14 md:gap-6">
                {items.map((hit) => {
                    if (hit.pageType !== 'pageCaseStudy') return null;
                    const itemSize = hit.__position < 7 ? 'large' : 'small';
                    const listItemClasses = classNames({
                        'md:col-start-2 md:col-span-12': itemSize === 'large',
                        'md:col-span-6 md:col-start-2': itemSize === 'small' && hit.__position % 2 === 1,
                        'md:col-span-6 md:col-start-8': itemSize === 'small' && hit.__position % 2 === 0,
                    });
                    return (
                        <li
                            key={hit.objectID}
                            data-insights-object-id={hit.objectID}
                            data-insights-position={hit.__position}
                            data-insights-query-id={hit.__queryID}
                            className={listItemClasses}
                        >
                            <LinkWrapper className={`group gtm-search-hit__link`} href={hit.url}>
                                <CaseStudyItem
                                    summary={hit.summary}
                                    imageUrl={hit.image}
                                    title={hit.title}
                                    year={hit.year}
                                    itemSize={itemSize}
                                />
                            </LinkWrapper>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default SearchHitsCaseStudies;
